function getUiLabels(culture, overrides) {
    const language = culture.substring(0, 2).toLowerCase();
    const result = translations[`${culture.toLowerCase()}`] ?? translations[`${language}`];
    if (!result) {
        throw new Error(`Simple Configurator: Translations not found for culture ${culture}`);
    }
    return { ...result, ...(overrides ?? {}) };
}
const EN_DEFAULT = {
    saveChanges: 'Update cart',
    revertChanges: 'Keep original',
    quantity: 'Quantity',
    selectPreview: 'Select a preview',
    front: 'Front',
    back: 'Back',
    open: 'Open',
    close: 'Close',
    previewAlt: 'Document Preview',
    loadingError: 'Sorry, our system experienced a temporary glitch. Please give us just a minute and then try again.'
};
const ES_DEFAULT = {
    saveChanges: 'Actualizar cesta',
    revertChanges: 'Mantener original',
    quantity: 'Cantidad',
    selectPreview: 'Selecciona una vista previa',
    front: 'Anverso',
    back: 'Reverso',
    open: 'Abierto',
    close: 'Cerrar',
    previewAlt: 'Vista previa del documento',
    loadingError: 'Lo sentimos, se ha producido un problema técnico temporal. Inténtalo de nuevo en unos minutos.'
};
const IT_DEFAULT = {
    saveChanges: 'Aggiorna carrello',
    revertChanges: "Mantieni l'originale",
    quantity: 'Quantità',
    selectPreview: 'Scegli un’anteprima',
    front: 'Lato anteriore',
    back: 'Indietro',
    open: 'Apri',
    close: 'Chiudi',
    previewAlt: 'Anteprima documento',
    loadingError: 'Siamo spiacenti, si è verificato un problema temporaneo nel nostro sistema. Riprova tra un minuto.'
};
const PT_DEFAULT = {
    saveChanges: 'Atualizar cesto',
    revertChanges: 'Manter original',
    quantity: 'Quantidade',
    selectPreview: 'Selecione uma pré-visualização',
    front: 'Frente',
    back: 'Verso',
    open: 'Abrir',
    close: 'Fechar',
    previewAlt: 'Pré-visualização do documento',
    loadingError: 'Pedimos desculpa. O nosso sistema apresenta uma falha temporária. Tente novamente dentro de um minuto.'
};
const DA = {
    saveChanges: 'Opdater vogn',
    revertChanges: 'Behold original',
    quantity: 'Antal',
    selectPreview: 'Vælg en forhåndsvisning',
    front: 'Forside',
    back: 'Tilbage',
    open: 'Åbn',
    close: 'Luk',
    previewAlt: 'Se dokument',
    loadingError: 'Beklager, der er sket en midlertidig fejl i vores system. Vent et øjeblik, og prøv så igen.'
};
const FI = {
    saveChanges: 'Päivitä ostoskori',
    revertChanges: 'Säilytä alkuperäinen',
    quantity: 'Määrä',
    selectPreview: 'Valitse esikatselu',
    front: 'Etupuoli',
    back: 'Kääntöpuoli',
    open: 'Avaa',
    close: 'Sulje',
    previewAlt: 'Asiakirjan esikatselu',
    loadingError: 'Valitettavasti järjestelmässämme ilmeni tilapäinen häiriö. Ole hyvä ja odota minuutti, ja yritä sitten uudestaan.'
};
const NL = {
    saveChanges: 'Winkelwagentje bijwerken',
    revertChanges: 'Origineel behouden',
    quantity: 'Aantal',
    selectPreview: 'Selecteer een voorbeeld',
    front: 'Voorkant',
    back: 'Achterkant',
    open: 'Open',
    close: 'Sluiten',
    previewAlt: 'Voorbeeld document',
    loadingError: 'Sorry, ons systeem werkt even niet mee. Probeer het over een minuutje nog een keer.'
};
const FR = {
    saveChanges: 'Actualiser le panier',
    revertChanges: "Conserver l'original",
    quantity: 'Quantité',
    selectPreview: 'Choisissez un aperçu',
    front: 'Recto',
    back: 'Retour',
    open: 'Ouvert',
    close: 'Fermer',
    previewAlt: 'Aperçu du document',
    loadingError: 'Désolé, un problème temporaire est survenu dans notre système. Veuillez attendre un instant et réessayer.'
};
const DE = {
    saveChanges: 'Warenkorb aktualisieren',
    revertChanges: 'Beim Original bleiben',
    quantity: 'Menge',
    selectPreview: 'Wählen Sie eine Vorschau',
    front: 'Vorderseite',
    back: 'Zurück',
    open: 'Geöffnet',
    close: 'Schließen',
    previewAlt: 'Dokumentvorschau',
    loadingError: 'Wir haben vorübergehende technische Probleme. Bitte entschuldigen Sie etwaige Unannehmlichkeiten. Wir arbeiten an der Behebung. Versuchen Sie es bitte später noch einmal.'
};
const NB = {
    saveChanges: 'Oppdater handlevogn',
    revertChanges: 'Behold original',
    quantity: 'Ant.',
    selectPreview: 'Velg en forhåndsvisning',
    front: 'Forside',
    back: 'Bakside',
    open: 'Åpne',
    close: 'Lukk',
    previewAlt: 'Forhåndsvisning av dokument',
    loadingError: 'Beklager, men det har oppstått en midlertidig feil i systemet. Vent et par minutter og prøv igjen.'
};
const SV = {
    saveChanges: 'Uppdatera kundvagn',
    revertChanges: 'Behåll original',
    quantity: 'Antal',
    selectPreview: 'Välj en förhandsvisning',
    front: 'Framsida',
    back: 'Baksida',
    open: 'Öppet',
    close: 'Stäng',
    previewAlt: 'Förhandsgranska dokument',
    loadingError: 'Vi beklagar, ett tillfälligt fel tycks ha uppstått i vårt system. Vi ber dig att vänta någon minut och sedan försöka igen.'
};
const translations = {
    en: EN_DEFAULT,
    es: ES_DEFAULT,
    it: IT_DEFAULT,
    pt: PT_DEFAULT,
    'en-GB': EN_DEFAULT,
    da: DA,
    de: DE,
    fi: FI,
    fr: FR,
    nb: NB,
    nl: NL,
    sv: SV,
};

export { getUiLabels, translations };
//# sourceMappingURL=localization.mjs.map
